import { z } from "zod";

// Skema untuk data anak (level ruangan)
const ReportAgentChildSchema = z.object({
    room_type: z.string(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
});

// Skema untuk data utama (level agen)
const ReportAgentDataV4Schema = z.object({
    agent_name: z.string(),
    color: z.string(),
    percentage: z.number(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
    children: z.array(ReportAgentChildSchema),
});

// Skema untuk objek 'total' pada respons
const ReportAgentTotalSchema = z.object({
    percentage: z.number(),
    room_nights: z.number(),
    reservations: z.number(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number(),
});

// Skema untuk keseluruhan respons API
export const ReportAgentResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReportAgentDataV4Schema),
    total: ReportAgentTotalSchema,
});

// Ekspor tipe TypeScript yang diambil dari skema Zod
export type ReportAgentResponseV4 = z.infer<typeof ReportAgentResponseV4Schema>;
export type ReportAgentDataV4 = z.infer<typeof ReportAgentDataV4Schema>;